<n-slide-window id="create_cifs_share_slidewindow"
    *ngIf="pageReady"
    [visible]="windowVisible"
    width="8rem"
    [loading]="loading"
    (onHide)="close()">
    <n-header>
        <h1>{{createAsShare? i18n.title.createAsTitle : title}}</h1>
        <n-help-link [key]="createAsShare? 'cifsCopy' : 'cifsCreate'"></n-help-link>
        <n-checkbox *ngIf="!slideWindow?.showBatch"
            id="create-cifs-share_advanced"
            style="margin-left: auto;"
            [label]="i18n.label.advance"
            [(ngModel)]="advanced">
        </n-checkbox>
    </n-header>

    <n-block [title]="i18n.title.basicInfo">
        <form [errorMessage]="errorMessage" [formGroup]="vm" class="common-form">
            <!-- 所属租户 -->
            <n-form-item [label]="i18n.label.vStoreLab">
                <div id="create-cifs-share-vstore" class="n-form-item-text">{{vstoreName || UNPLACEHOLDER}}</div>
            </n-form-item>
            <!-- 文件系统 -->
            <n-form-item [label]="i18n.label.fileSystem" [required]="canFileSystemChange">
                <div class="interval-10 custom-width"
                    *ngIf="canFileSystemChange; else fsText">
                    <n-select #fsSelect
                        id="create-cifs-share-fs"
                        [rest]="fileSystemRest"
                        [valueField]="'ID'"
                        [labelField]="'NAME'"
                        [filter]="true"
                        formControlName="FS"
                        (onChange)="onChooseFileSystem($event)">
                    </n-select>
                    <button nButton
                        id="create_cifs-share-create-fs"
                        type="button"
                        [label]="i18n.btn.createBtn"
                        [disabled]="createFsDisabled"
                        (click)="createFs()">
                    </button>
                </div>
                <ng-template #fsText>
                    <div class="n-form-item-text">{{fileSystem?.NAME || UNPLACEHOLDER}}</div>
                </ng-template>
                <p class="sub mt-5" *ngIf="canFileSystemChange && selectedFilesystem?.isAuditLogFs">{{i18n.label.auditFs}}</p>
            </n-form-item>
            <!-- dtree -->
            <n-form-item *ngIf="showDtree && hasDtreePermission" [label]="i18n.label.dtree">
                <n-select id="create-cifs-share-dtree"
                    *ngIf="canDtreeChange; else dtreeText"
                    [rest]="dtreeRest"
                    [valueField]="'ID'"
                    [labelField]="'NAME'"
                    [filter]="!!dtreeRest"
                    formControlName="dtree"
                    [clearBtn]="true"
                    (onChange)="onChooseDtree($event)">
                </n-select>
                <ng-template #dtreeText>
                    <div class="text-wrap n-form-item-text">{{dtree?.NAME || UNPLACEHOLDER}}</div>
                </ng-template>
                <n-tip type="warning" *ngIf="dtreePathHasBackslash"
                    [content]="i18n.tip.dtreePathHasBackslash">
                </n-tip>
            </n-form-item>
            <!-- 共享名 -->
            <n-form-item
                [label]="i18n.label.share_name"
                required="true">
                <input type="text"
                    id="create_cifs_share_name"
                    nInput
                    formControlName="NAME"
                    [placeholder]="errorMessage.NAME.rangeByteLength">
            </n-form-item>
            <!-- 共享路径，只展示 -->
            <n-form-item [required]="false" [label]="i18n.label.share_path">
                <n-inline-loading *ngIf="pathLoading" state="loading"></n-inline-loading>
                <div *ngIf="!pathLoading"
                    id="create-cifs-share-share_path"
                    class="text-wrap n-form-item-text">
                    {{share_path || UNPLACEHOLDER}}
                </div>
            </n-form-item>

            <!-- 高级选项 -->
            <ng-container *ngIf="advanced">
                <!-- 描述 -->
                <n-form-item [label]="i18n.label.description">
                    <textarea id="create-cifs-share-description"
                        nTextarea
                        formControlName="DESCRIPTION"
                        [placeholder]="errorMessage.DESCRIPTION.rangeByteLength">
                    </textarea>
                </n-form-item>
                <!-- Notify -->
                <n-form-item [label]="i18n.label.notify"
                    [helpContent]="i18n.tip.notify">
                    <n-checkbox id="create-cifs-share-notify"
                        style="margin-left: auto;"
                        [label]="i18n.label.enable"
                        formControlName="ENABLENOTIFY">
                    </n-checkbox>
                </n-form-item>
                <!-- 是否启用CA -->
                <n-form-item [label]="i18n.label.enableCa"
                    [helpContent]="i18n.tip.enableCa">
                    <n-checkbox id="create-cifs-share-enable-ca"
                        style="margin-left: auto;"
                        [label]="i18n.label.enable"
                        formControlName="ENABLECA">
                    </n-checkbox>
                </n-form-item>
                <!-- 是否启用SMB3加密 -->
                <n-form-item [label]="i18n.label.smb3EncryptionEnable"
                    [helpContent]="i18n.tip.smb3EncryptionEnable">
                    <n-checkbox id="create-cifs-share-smb3EncryptionEnable"
                        style="margin-left: auto;"
                        [label]="i18n.label.enable"
                        formControlName="smb3EncryptionEnable">
                    </n-checkbox>
                </n-form-item>
                <!-- 是否启用拒绝非加密客户端访问 -->
                <n-form-item [label]="i18n.label.unencryptedAccess"
                    [helpContent]="i18n.tip.unencryptedAccess">
                    <n-checkbox id="create-cifs-share-unencryptedAccess"
                        style="margin-left: auto;"
                        [label]="i18n.label.enable"
                        formControlName="unencryptedAccess">
                    </n-checkbox>
                </n-form-item>
                <!-- 是否启用ABE -->
                <n-form-item [label]="i18n.label.ABE"
                    [helpContent]="i18n.tip.ABE">
                    <n-checkbox id="create-cifs-share-ABE"
                        style="margin-left: auto;"
                        [label]="i18n.label.enable"
                        formControlName="ABEENABLE">
                    </n-checkbox>
                </n-form-item>
                <!-- 显示以前的版本 -->
                <n-form-item [label]="i18n.label.showPreviousVersion"
                    [helpContent]="i18n.label.showPreviousVersionTip">
                    <n-checkbox id="create-cifs-share-enableShowPreviousVersion"
                        [label]="i18n.label.enable"
                        formControlName="ENABLESHOWPREVIOUSVERSIONS">
                    </n-checkbox>
                </n-form-item>
                 <!-- 显示Snapshot -->
                <n-form-item [label]="i18n.label.showSnapShotLab"
                    [helpContent]="i18n.label.showSnapShotTip">
                    <n-checkbox id="create-cifs-share-enableShowSnapshot"
                        [label]="i18n.label.enable"
                        formControlName="ENABLESHOWSNAPSHOT">
                    </n-checkbox>
                </n-form-item>
                <!-- 离线文件缓存模式 -->
                <n-form-item [label]="i18n.label.offlineCacheModeLab"
                    [helpContent]="i18n.tip.offLineFileModeTip">
                    <n-select id="create-cifs-share-offLineFileMode"
                        [options]="str.fileModeOpts"
                        formControlName="OFFLINEFILEMODE">
                    </n-select>
                </n-form-item>
            </ng-container>
        </form>
    </n-block>
    <!-- 权限列表 -->
    <n-block [title]="i18n.title.permissionList"
        class="clients-tip">
        <n-loading  [visible]="allUserLoading"></n-loading>
        <p class="mb-10">{{i18n.tip.clientsTip}}</p>
        <app-front-table-client-cifs-share
            [supportSmartGui]="supportSmartGui"
            [isCopyFrom]='!!copyFromStyle'
            [(tableData)]="userList"
            [selectFs]="selectedFilesystem"
            (clickAddBtn)="onClickAddBtn()"
            [vstoreId]="vstoreId"
            [vstoreName]="vstoreName"
            [entry]="entry">
        </app-front-table-client-cifs-share>
    </n-block>
    <n-footer>
        <button id="create-cifs-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="create-cifs-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
